import * as CONST from 'Reducers/Upload/const'

export const uploadProfileImage = (profileId, image, callbacks) => ({
  type: CONST.UPLOAD_PROFILE_IMAGE,
  profileId,
  image,
  callbacks,
})

export const uploadClientImage = (clientId, image, callbacks) => ({
  type: CONST.UPLOAD_CLIENT_IMAGE,
  clientId,
  image,
  callbacks,
})

/**
 * Upload a pitch file
 * @param {string} profileId
 * @param {File} file
 * @param {object} callback Can have key 'onSuccess'
 * @returns {object}
 */
export const uploadPitchFile = (campaignId, file, callbacks) => ({
  type: CONST.UPLOAD_PITCH_FILE,
  campaignId,
  file,
  callbacks,
})

/**
 * Upload a file
 * @param {File} file
 */
export const uploadFile = (file, callbacks, mimeType) => ({
  type: CONST.UPLOAD_FILE,
  file,
  callbacks,
  mimeType,
})
